import React from 'react';

import CustomTd from '../table/CustomTd';
import FormControl from '../inputs/FormControl';
import PropTypes from 'prop-types';
import SaveCancelButton from '../buttons/SaveCancelButton';
import SelectList from '../inputs/SelectList';
import useForm from '../../../utilities/useForm';

const NameFranchiseEditor = ({
    cancelEdit,
    fetchData,
    getUrl,
    item: initialItem,
    postUrl,
    hideFranchise,
    showExternal
}) => {
    //if the initial item has a zero id, do a round trip to API to get a new item
    //this allows us to perform logic server side to create objects
    const { item, ...form } = useForm(getUrl, postUrl, initialItem === undefined || initialItem === null || initialItem.id === 0 ? null : { item: initialItem });

    const submitForm = () => {
        form.submitData(() => {
            cancelEdit();
            fetchData();
        });
    }

    return (
        <tr>
            <CustomTd>
                <div style={{ height: '1.9em' }}>
                    <FormControl
                        name='name'
                        defaultValue={item ? item.name : ''}
                        onChange={form.formChange}
                        validationError={item ? item.name_error : ''}
                    />
                </div>
            </CustomTd>
            {window.biztrax.showFranchise && !hideFranchise &&
                <CustomTd>
                    <SelectList
                        name={'franchiseId'}
                        value={item ? item.franchiseId : 0}
                        validationError={item ? item.franchiseId_error : ''}
                        lookupType={'Franchise'}
                        onChange={form.formChange} />
                </CustomTd>
            }
            {showExternal &&
                <CustomTd>
                    <div className="d-flex" style={{ paddingTop: '2px' }}>
                        <label className="custom-control custom-checkbox d-inline-flex mb-0">
                            <input type="checkbox"
                                checked={item ? item.externallyVisible : false}
                                className="custom-control-input"
                                name="externallyVisible"
                                onChange={form.formChange}
                            />
                            <span className="custom-control-label">&nbsp;</span>
                        </label>
                    </div>
                </CustomTd>    
            }
            <CustomTd className="two-button-cell">
                <SaveCancelButton saveItem={submitForm} cancelEdit={cancelEdit} />
            </CustomTd>
        </tr>
    );
}

NameFranchiseEditor.propTypes = {
    cancelEdit: PropTypes.func,
    fetchData: PropTypes.func,
    getUrl: PropTypes.string,
    hideFranchise: PropTypes.bool,
    postUrl: PropTypes.string.isRequired
};

export default NameFranchiseEditor;